var convertToUnixTimestamp = function convertToUnixTimestamp(date) {
  return date.unix().toString();
};
export default convertToUnixTimestamp;